import { useTranslation } from 'react-i18next';
import { IAppNotification } from '../../appBackend/useAppNotifications';
import BaseNotificationContent from './BaseNotificationContent';

export default function NewSiteContent({ notification }:{notification: IAppNotification}) {
  const { t } = useTranslation();
  const { siteNames } = notification.jsonPayload
    ? JSON.parse(notification.jsonPayload) as { siteNames: string }
    : { siteNames: '' };
  return (
    <BaseNotificationContent
      title={t('NewSite')}
      description={t('YouHaveBeenAddedToANewSite', { siteNames })}
      createdAt={notification.createdAt}
    />
  );
}
